import { Step } from '../components/steps/Step';
import { OnboardingFlows } from './common';

export const contentTypeHR: Step = {
    id: OnboardingFlows.UseCases,
    title: 'How do you plan to use D-ID?',
    showCondition: {
        stepId: OnboardingFlows.NewDepartment,
        selectedOption: 'HR',
    },
    multiSelect: false,
    randomize: true,
    options: [
        {
            label: 'Interactive conversational Avatars',
        },
        {
            label: 'Compliance training',
        },
        {
            label: 'Operations training',
        },
        {
            label: 'Internal comms',
        },
        {
            label: 'Employee onboarding',
        },
        {
            label: 'Employee training',
        },
        {
            label: 'Soft-skills training',
        },
        {
            label: 'Policy update',
        },
        {
            label: 'Other',
        },
    ],
};
